<template>
  <div class="row">
    <div class="col-6">
      <p class="lead">Dificuldades de Implementação</p>
      <div v-if="!printing" class="d-flex">
        <router-link
          to="/action-plan/form"
          class="btn btn-success"
        >
          <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
          Voltar ao Plano de Ação
        </router-link>
        <div class="save-button ml-3">
          <button @click="save()" class="btn btn-primary">Salvar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="mt-4 w-80">
      <Panel class="panel-custom" header="Dificuldades de implementação">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Necessita parada de produção?'"
                  :options="needsProductionStopOptions"
                  v-model="needsProductionStopOption"
                />
              </div>
              <div class="form-group">
                <label>Conseguimos mensurar o tempo?</label>
                <input v-model="timeMeasurement" type="text" class="form-control" />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Necessita execução em horários especiais?'"
                  :options="needsExecutionAtSpecialTimesOptions"
                  v-model="needsExecutionAtSpecialTimesOption"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Necessita desligamento da rede elétrica?'"
                  :options="needsDisconnectFromElectricalNetworkOptions"
                  v-model="needsDisconnectFromElectricalNetworkOption"
                  :mode="'inline'"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Área de acesso controlado?'"
                  :options="controlledAccessAreaOptions"
                  v-model="controlledAccessAreaOption"
                  :mode="'inline'"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Tempo permanência área limitado?'"
                  :options="limitedLengthOfStayOptions"
                  v-model="limitedLengthOfStayOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar Motivo:</label>
                <input
                  v-model="limitedLengthOfStayDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Dificuldade de acesso?'"
                  :options="accessDifficultyOptions"
                  v-model="accessDifficultyOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar Motivo:</label>
                <input
                  v-model="accessDifficultyDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Espaço de trabalho limitado?'"
                  :options="limitedWorkSpaceOptions"
                  v-model="limitedWorkSpaceOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar Motivo:</label>
                <input
                  v-model="limitedWorkSpaceDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Superfície com alta temperatura?'"
                  :options="highTemperatureSurfaceOptions"
                  v-model="highTemperatureSurfaceOption"
                  :mode="'inline'"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Envolve trabalhos especiais?'"
                  :options="involvesSpecialJobsOptions"
                  v-model="involvesSpecialJobsOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar qual:</label>
                <input
                  v-model="involvesSpecialJobsDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Algum equipamento ou EPI especial necessário?'"
                  :options="needsSpecialEpiOptions"
                  v-model="needsSpecialEpiOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar qual:</label>
                <input
                  v-model="needsSpecialEpiDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="content">
              <div class="form-group">
                <custom-select-button
                  :title="'Alguma outra dificuldade observada?'"
                  :options="otherDifficultiesOptions"
                  v-model="otherDifficultiesOption"
                  :mode="'inline'"
                />
              </div>
              <div class="form-group">
                <label>Citar qual:</label>
                <input
                  v-model="otherDifficultiesDetails"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
  import { useRoute } from 'vue-router'

  import useSwal from '@/modules/Swal.js'
  import useActionPlanImplementationDifficultiesForm from '@/modules/ActionPlanImplementationDifficultiesForm.js'

  import Panel from 'primevue/panel'
  import CustomSelectButton from '@/components/common/CustomSelectButton/CustomSelectButton.vue'

  export default {
    setup() {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showConfirmDeletionSwal } = useSwal()
      const { showSuccessDialog } = useSwal()

      const {
        needsProductionStopOptions,
        needsExecutionAtSpecialTimesOptions,
        needsDisconnectFromElectricalNetworkOptions,
        controlledAccessAreaOptions,
        accessDifficultyOptions,
        limitedLengthOfStayOptions,
        limitedWorkSpaceOptions,
        highTemperatureSurfaceOptions,
        involvesSpecialJobsOptions,
        needsSpecialEpiOptions,
        otherDifficultiesOptions,

        needsProductionStopOption,
        timeMeasurement,
        needsExecutionAtSpecialTimesOption,
        needsDisconnectFromElectricalNetworkOption,
        controlledAccessAreaOption,
        limitedLengthOfStayOption,
        limitedLengthOfStayDetails,
        accessDifficultyOption,
        accessDifficultyDetails,
        limitedWorkSpaceOption,
        limitedWorkSpaceDetails,
        highTemperatureSurfaceOption,
        involvesSpecialJobsOption,
        involvesSpecialJobsDetails,
        needsSpecialEpiOption,
        needsSpecialEpiDetails,
        otherDifficultiesOption,
        otherDifficultiesDetails,

        clearForm,
        fillForm,
      } = useActionPlanImplementationDifficultiesForm()

      return {
        riskAnalysisDescriptionId,
        showConfirmDeletionSwal,
        showSuccessDialog,
        clearForm,
        fillForm,

        needsProductionStopOptions,
        needsExecutionAtSpecialTimesOptions,
        needsDisconnectFromElectricalNetworkOptions,
        controlledAccessAreaOptions,
        accessDifficultyOptions,
        limitedLengthOfStayOptions,
        limitedWorkSpaceOptions,
        highTemperatureSurfaceOptions,
        involvesSpecialJobsOptions,
        needsSpecialEpiOptions,
        otherDifficultiesOptions,

        needsProductionStopOption,
        timeMeasurement,
        needsExecutionAtSpecialTimesOption,
        needsDisconnectFromElectricalNetworkOption,
        controlledAccessAreaOption,
        limitedLengthOfStayOption,
        limitedLengthOfStayDetails,
        accessDifficultyOption,
        accessDifficultyDetails,
        limitedWorkSpaceOption,
        limitedWorkSpaceDetails,
        highTemperatureSurfaceOption,
        involvesSpecialJobsOption,
        involvesSpecialJobsDetails,
        needsSpecialEpiOption,
        needsSpecialEpiDetails,
        otherDifficultiesOption,
        otherDifficultiesDetails,
      }
    },
    components: {
      Panel,
      CustomSelectButton,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/difficulties`,
          )
          .then(({ data }) => {
            this.clearForm()
            this.fillForm(data)
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          needsProductionStopOption: this.needsProductionStopOption,
          timeMeasurement: this.timeMeasurement,
          needsExecutionAtSpecialTimesOption: this.needsExecutionAtSpecialTimesOption,
          needsDisconnectFromElectricalNetworkOption: this.needsDisconnectFromElectricalNetworkOption,
          controlledAccessAreaOption: this.controlledAccessAreaOption,
          limitedLengthOfStayOption: this.limitedLengthOfStayOption,
          limitedLengthOfStayDetails: this.limitedLengthOfStayDetails,
          accessDifficultyOption: this.accessDifficultyOption,
          accessDifficultyDetails: this.accessDifficultyDetails,
          limitedWorkSpaceOption: this.limitedWorkSpaceOption,
          limitedWorkSpaceDetails: this.limitedWorkSpaceDetails,
          highTemperatureSurfaceOption: this.highTemperatureSurfaceOption,
          involvesSpecialJobsOption: this.involvesSpecialJobsOption,
          involvesSpecialJobsDetails: this.involvesSpecialJobsDetails,
          needsSpecialEpiOption: this.needsSpecialEpiOption,
          needsSpecialEpiDetails: this.needsSpecialEpiDetails,
          otherDifficultiesOption: this.otherDifficultiesOption,
          otherDifficultiesDetails: this.otherDifficultiesDetails,
        }

        let formData = new FormData()

        Object.keys(payload).forEach((field) =>
          formData.append(field, payload[field]),
        )

        this.axios
          .post(`/api/action-plan/services/difficulties`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => this.showSuccessDialog())
      }
    },
    mounted() {
      this.load()
    },
  }
</script>

<style lang="scss" scoped>
  .panel-custom {
    ::v-deep(.p-panel-header) {
      background-color: white;

      justify-content: center;
    }

    ::v-deep(.p-panel-content) {
      padding: 0;

      .content {
        padding: 10px 20px;

        &:nth-child(2n + 1) {
          background-color: #fafafa;
        }
      }
    }
  }
</style>
